import type { ReactNode } from "react"
import { createContext, useContext } from "react"

import type {
	CustomDataTarget,
	SidebarSectionComponent,
} from "@productlane/api/src/browser"

interface SidebarSectionContextValue {
	sectionId: string
	target: CustomDataTarget
	/** Action names the Productlane Agent may run; the rest need a person to confirm them. */
	agentActions: ReadonlySet<string>
	onActionResult: (components?: SidebarSectionComponent[]) => void
}

const SidebarSectionContext = createContext<SidebarSectionContextValue | null>(
	null,
)

export function SidebarSectionProvider({
	value,
	children,
}: {
	value: SidebarSectionContextValue
	children: ReactNode
}) {
	return (
		<SidebarSectionContext.Provider value={value}>
			{children}
		</SidebarSectionContext.Provider>
	)
}

export function useSidebarSectionContext() {
	const value = useContext(SidebarSectionContext)
	if (!value) {
		throw new Error("useSidebarSectionContext used outside a sidebar section")
	}
	return value
}
